module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan2-3-847ecd304a88167047dbd6b3c30e3167.webp";